import { render } from "./StepThree.vue?vue&type=template&id=54b7a1da&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import "./StepThree.vue?vue&type=style&index=0&id=54b7a1da&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b7a1da"]])

export default __exports__